export default [
  'Functional programming',
  'Language design',
  'Code golf in Haskell',
  'Deep neural networks',
  'UX',
  'App development',
  'DX',
  'Security',
  'Performance',
  'User interface design',
  'Dogs 🐶'
]
